import { GridCellProps } from '@progress/kendo-react-grid';

type Props = {
  e: GridCellProps;
  onClick?: (e) => void;
};

export const BackNumberCell = ({ e, onClick }: Props) => {
  const data = e.dataItem.backNumber;
  return (
    <td style={{ alignItems: 'center' }}>
      <div>{data}</div>
    </td>
  );
};
